const imageSliderTimeout = 8 * 1000;

let imageSlider;

const sliderElement = document.querySelector(".page-intro-slider");

if (sliderElement) ready(() => {
	imageSlider = new imageCarousel(document.querySelector(".page-intro-slider"));
	imageSlider.show();

	document.querySelector(".toggle-image.prev-image").addEventListener("click", () => imageSlider.prev());
	document.querySelector(".toggle-image.next-image").addEventListener("click", () => imageSlider.next());

	window.addEventListener("keyup", (event) => {
		if (event.keyCode === 37) return imageSlider.prev();
		if (event.keyCode === 39) return imageSlider.next();

		// if (event.keyCode === 27) {
		// 	document.documentElement.style.overflow = "auto";
		// 	return imageSliderContainer.classList.remove("is-active");
		// }
	});

	setInterval(() => {
		imageSlider.next()
	}, imageSliderTimeout);
});
